var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoQualifies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.5C17.6279 2.5 22 6.87211 22 12.25C22 17.6279 17.6279 22 12.25 22C6.87211 22 2.5 17.6279 2.5 12.25C2.5 6.87211 6.87211 2.5 12.25 2.5ZM17.3428 7.1543C16.759 6.5708 15.7927 6.5707 15.209 7.1543L12.25 10.1133L9.29102 7.1543C8.70731 6.57069 7.741 6.5708 7.15723 7.1543C6.57348 7.73804 6.57354 8.7043 7.15723 9.28809L10.1162 12.248L7.15723 15.207C6.57354 15.7908 6.57348 16.7571 7.15723 17.3408C7.45905 17.6425 7.84137 17.7831 8.22363 17.7832C8.60607 17.7832 8.98908 17.6427 9.29102 17.3408L12.25 14.3818L15.209 17.3408C15.5109 17.6427 15.8939 17.7832 16.2764 17.7832C16.6586 17.7831 17.0409 17.6425 17.3428 17.3408C17.9265 16.7571 17.9265 15.7908 17.3428 15.207L14.3838 12.248L17.3428 9.28809C17.9265 8.7043 17.9265 7.73804 17.3428 7.1543Z",
    fill: "#E64D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoQualifies);
export default __webpack_public_path__ + "static/media/no-qualifies.0fe3be6e13e655122c16753fb0ab0ef3.svg";
export { ForwardRef as ReactComponent };